import { Col, Collapse, Form, Radio, Row, Button } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PersonalDetails from "./PersonalDetails";
import EmploymentDetails from "./EmploymentDetails";
import { Field, Formik } from "formik";
import CommonDocumentUpload from "./CommonDocumentUpload";
import { InitialData } from "../../common/InitialData";
import GuarantorDocumentUpload from "./GuarantorDocumentUpload";
import GuarantorPersonalDetails from "./GuarantorPersonalDetails";
import ConfirmationModalGuarantor from "./modals/ConfirmationModalGuarantor";

const Guarantor = ({
  guarantor_index,
  updateFunction,
  isApplicationGuarantor,
  applicationID,
  existingGuarantors,
  minIncome,
  notificationGuarantorId,
}) => {
  const guarantorref = useRef();
  const [guarantordata, setGuarantorData] = useState({});
  const [guarantorType, setGuarantorType] = useState("");
  const [applicantModal, setApplicantModal] = useState(false);
  const [applicantValues, setApplicantValues] = useState("");

  const handleChange = (e, formikProps) => {
    const { name, value } = e.target;
    let data = { ...formikProps.values };
    data[name] = value;
    if (data["guarantor_type"] == "company") {
      data["guarantor_citizenship_type"] = "";
    }
    setGuarantorData(data);
    localStorage.setItem(
      "guarantor_details_" + guarantor_index,
      JSON.stringify(data)
    );
  };

  const guarantordetails = [
    {
      key: "1",
      label: "Guarantor Details",
      children: (
        <GuarantorPersonalDetails
          type={"guarantor"}
          guarantor_index={guarantor_index}
          existingGuarantors={existingGuarantors}
          guarantor_type={"individual"}
        />
      ),
    },
    {
      key: "2",
      label: "Guarantor’s Employment & Financial Declaration",
      children: (
        <EmploymentDetails
          type={"guarantor"}
          guarantor_index={guarantor_index}
          minIncome={minIncome}
        />
      ),
    },
    {
      key: "3",
      label: "Upload Documents",
      children: (
        <GuarantorDocumentUpload
          documentHolderType={"guarantor_documents"}
          guarantor_index={guarantor_index}
          updateFunction={updateFunction}
          guarantor_type={guarantordata.guarantor_type}
          isApplicationGuarantor={isApplicationGuarantor}
          guarantordata={guarantordata}
        />
      ),
    },
  ];

  const savedNotificationGuarantorId = localStorage.getItem("notificationGuarantorId_" + guarantor_index);
  const companyDetails = [
    {
      key: "1",
      label: "Guarantor Details",
      children: (
        <GuarantorPersonalDetails
          type={"guarantor"}
          guarantor_index={guarantor_index}
          guarantor_type={"company"}
          notificationGuarantorId={savedNotificationGuarantorId}
        />
      ),
    },
    {
      key: "2",
      label: "Upload Documents",
      children: (
        <GuarantorDocumentUpload
          documentHolderType={"guarantor_documents"}
          guarantor_index={guarantor_index}
          updateFunction={updateFunction}
          guarantor_type={guarantordata.guarantor_type}
          isApplicationGuarantor={isApplicationGuarantor}
          guarantordata={guarantordata}
        />
      ),
    },
  ];

  const handleModalYesClick = () => {
    // Update the radio button value and close the modal
    setGuarantorType(localStorage.getItem("guarantor_type_" + guarantor_index));
    let data = { ...guarantordata };
    data.guarantor_citizenship_type = "";
    data.guarantor_type = localStorage.getItem(
      "guarantor_type_" + guarantor_index
    );
    localStorage.setItem(
      "guarantor_details_" + guarantor_index,
      JSON.stringify(data)
    );
    setGuarantorData(data);
    updateFunction("step5", "viewed", false);
    updateFunction("step5", "completed", false);
    setApplicantModal(false);
  };

  useEffect(() => {
    let savedValues = {};
    savedValues = localStorage.getItem("guarantor_details_" + guarantor_index);
    if (savedValues && Object.keys(savedValues).length != 0) {
      const parsedValues = JSON.parse(savedValues);
      setGuarantorType(parsedValues.guarantor_type);
      setGuarantorData(parsedValues);
    } else {
      setGuarantorData(InitialData.guarantor_data);
    }
  }, []);

  useEffect(() => { }, [guarantordata]);

  // ✅ Save notificationGuarantorId to localStorage for persistence
  useEffect(() => {
    if (notificationGuarantorId) {
      localStorage.setItem(
        "notificationGuarantorId_" + guarantor_index,
        notificationGuarantorId
      );
    }
  }, [notificationGuarantorId, guarantor_index]);

  return (
    <div className="ml-5">
      <Formik
        enableReinitialize={true}
        initialValues={guarantordata}
        innerRef={guarantorref}
      >
        {(formikProps) => (
          <Form layout="vertical">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={12} lg={12}>
                <div className="px-5">
                  <div className="mb-2">
                    <label className="text-[15px] font-lato text-[700]">
                      Who is guarantor?&nbsp;
                      <span className="text-instruction-red text-[12px] text-[400] font-lato">
                        {formikProps.values.guarantor_type == "" &&
                          "Only an Local Individual / Company can be a guarantor"}
                      </span>
                    </label>
                  </div>
                  <div className="mb-5">
                    <Field name="guarantor_type" className="mb-5">
                      {({ field }) => (
                        <Radio.Group
                          {...field}
                          onChange={(e) => {
                            if (guarantorType != "") {
                              setApplicantModal(true);
                              let data = {
                                value: e.target.value,
                              };
                              setApplicantValues(data);
                            } else {
                              setGuarantorType(e.target.value);
                              handleChange(e, formikProps);
                            }
                          }}
                          value={guarantorType}
                        >
                          <Radio key={1} value={"individual"}>
                            <p className="form-field-label">An individual</p>
                          </Radio>
                          <Radio key={0} value={"company"}>
                            <p className="form-field-label">A Local Company</p>
                          </Radio>
                        </Radio.Group>
                      )}
                    </Field>
                  </div>
                </div>
              </Col>
            </Row>
            {guarantorType == "individual" && (
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <div className="px-5">
                    <div className="mb-2">
                      <label className="text-[15px] font-lato text-[700]">
                        Is the guarantor Singapoean or PR?&nbsp;
                        <span className="text-instruction-red text-[12px] text-[400] font-lato">
                          {formikProps.values.guarantor_citizenship_type ==
                            "" && "Guarantor must be singaporean or PR"}
                        </span>
                      </label>
                    </div>
                    <div className="mb-5">
                      <Field name="guarantor_citizenship_type" className="mb-5">
                        {({ field }) => (
                          <Radio.Group
                            {...field}
                            onChange={(e) => handleChange(e, formikProps)}
                            disabled={guarantorType == "company" ? true : false}
                          >
                            <Radio key={1} value={"singaporean"}>
                              <p className="form-field-label">Singaporean</p>
                            </Radio>
                            <Radio key={0} value={"pr"}>
                              <p className="form-field-label">PR</p>
                            </Radio>
                          </Radio.Group>
                        )}
                      </Field>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
            {guarantorType == "individual" &&
              (formikProps.values.guarantor_citizenship_type == "singaporean" ||
                formikProps.values.guarantor_citizenship_type == "pr") && (
                <React.Fragment>
                  <div className="child-radio-group !block">
                    <div className="w-3/3 text-center">
                      <h2 className="!text-singpass-red-color">Singpass</h2>
                      <p>Speed up your application using Myinfo</p>
                      <Button
                        onClick={(e) => {
                          let guarantorId = "";
                          if (
                            Array.isArray(existingGuarantors) &&
                            existingGuarantors.length > 0 &&
                            guarantor_index > 0 &&
                            existingGuarantors[guarantor_index - 1]?.id
                          ) {
                            guarantorId = `&guarantorId=${existingGuarantors[guarantor_index - 1].id}`;
                          }
                          const currentUrl = window.location.href; // e.g., "http://localhost:3000/dealer/case-detail"
                          let applicationID1 = applicationID ? applicationID : localStorage.getItem('applicationId')
                          let redirectUrl = `https://data.ohhto.com/?application_id=${applicationID1}&isGuarantor=1${guarantorId}&redirectUrl=${currentUrl}`;
                          localStorage.setItem("SINGPASSAPPID", "");
                          window.location.href = redirectUrl;

                          localStorage.setItem("redirectStatus", true);
                          sessionStorage.setItem("singPassStatus", true);
                        }}
                        className="p-3 px-4 !inline-flex !items-center !gap-2
                                    !font-bold !text-white !text-base !leading-6
                                    !bg-[#F4333D] hover:!bg-[#F4333D]/90
                                    !border-none !rounded-[6px]
                                    !cursor-pointer !no-underline !whitespace-nowrap"
                      >
                        Log in with{" "}
                        <img
                          src="/images/singpass.svg"
                          className="h-6 w-auto"
                        />
                      </Button>

                      <p className="text-[11px] font-[400] font-lato text-[#495159]">
                        ~ 5 mins
                      </p>
                    </div>
                  </div>
                  <Collapse
                    className="loanCollapse-apply"
                    items={guarantordetails}
                    defaultActiveKey={["1", "2", "3"]}
                  />
                </React.Fragment>
              )}
            {guarantorType == "company" && (
              <Collapse
                className="loanCollapse-apply"
                items={companyDetails}
                defaultActiveKey={["1", "2"]}
              />
            )}
          </Form>
        )}
      </Formik>
      <ConfirmationModalGuarantor
        open={applicantModal}
        close={() => {
          setApplicantModal(false);
        }}
        onYesClick={handleModalYesClick}
        value={applicantValues.value}
        index={guarantor_index}
      />
    </div >
  );
};

export default Guarantor;
